<template>
  <div class="">
    <m-content-wrapper content-type="post" :slicer="slicer" :content-category="contentCategory"
                       :pause-if-category-not-found="true"
    >
      <template v-slot="{contents}">
        <div class="col-lg-12">
          <div class="row ">
            <div :class="itemClass" v-for="sub_content in setupContents(contents)"
                 :key="sub_content.id">
              <component :is="postCard"  :content="sub_content" />
            </div>
          </div>
        </div>

      </template>
    </m-content-wrapper>
  </div>
</template>

<script>
import mContentWrapper from "../../Wrappers/ContentWrapper";
import mIcon from "../../Icons/Icon";
import mA from "../../Tags/A";
import {Cards} from "../Card/Cards";

export default {
  name: "PostsRelated300",
  components: {mContentWrapper, mIcon, mA,...Cards},
  props: {
    content: {},
    contentCategory: {
      default: null
    },
    ignoreItem: {
      default: []
    },
    itemClass: {
      default: 'col-lg-4 my-3'
    },
    slicer: {
      default: 12
    },
    postCard: {
      options: Object.keys(Cards),
      default: 'mPostCard310'
    }
  },
  methods: {
    findCategories(categories) {
      categories = categories.map(item => {
        return item.slug
      })
      return categories.length == 0 ? null : categories
    },
    setupContents(contents) {

      contents = contents.filter(item => {
        return this.ignoreItem.indexOf(item.id) == -1
      })

      return contents

    }
  }
}
</script>

<style scoped>

</style>